import React from "react";
import history from "history/hash";

const RegistrationHeader = () => {
    const goHome = (event: any) => {
        event.preventDefault();
        history.push("/");
    }

    return (
        <header>
            <a href="/#" onClick={(e) => goHome(e)} title="DStv part of the MultiChoice group"></a>
        </header>
    );

}

export default RegistrationHeader;
